/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.OMS {
    var x;
    @Serenity.Decorators.registerClass()
    export class KaratRateEditor extends Common.GridEditorBase<KaratRateRow> {
        protected getColumnsKey() { return "OMS.KaratRate"; }
        protected getDialogType() { return KaratRateDialog; }
        protected getLocalTextPrefix() { return KaratRateRow.localTextPrefix; }

        protected form: KaratRateForm;

        
        constructor(container: JQuery) { 
            super(container); 


        }
        //public DisableAddButton() {
        //    this.toolbar.element.hide();
        //    this.element.hide();
        //}

        //public EnableAddButton() {
        //    this.toolbar.element.show();
        //    this.element.show();
            


        //} 
        /*
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.RawMaterialSelectGrid;
            // grid.apply(this.rowSelection = new Serenity.GridRowSelectionMixin(this));
            //grid.apply(this.getColumns = (Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            buttons.push({
                title: "Pick Products",
                cssClass: "add-button",
                onClick: () => {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.Product_Id)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.Product_Id == t.Product_Id) });
                        alert('Length' + selectedItems.length);
                        var orddetails = [];
                        var bomdetails = [];
                        selectedItems2.forEach(function (value) {
                            var prdid = value.Product_Id;
                            var atb = OMS.ProductRow.getLookup().itemById[prdid].Product_Attribute_Id;
                            var atbCode = OMS.CommonAttributesRow.getLookup().itemById[atb].Attribute;
                            var ItmTpy = OMS.CommonAttributesRow.getLookup().itemById[atb].ItemType;
                            var ItmTpyId = OMS.CommonAttributesRow.getLookup().itemById[atb].ItemTypeId;
                            var TypeID = OMS.CommonAttributesRow.getLookup().itemById[atb].CategoryId;
                            var SubType = OMS.CommonAttributesRow.getLookup().itemById[atb].SubCategoryCode;
                            var Karat = OMS.CommonAttributesRow.getLookup().itemById[atb].KaratCode;
                            var KaratId = OMS.CommonAttributesRow.getLookup().itemById[atb].Karat_Id;
                            var StoneColorID = OMS.CommonAttributesRow.getLookup().itemById[atb].Stone_Color_Id;
                            var Metal_Color_Id = OMS.CommonAttributesRow.getLookup().itemById[atb].Metal_Color_Id;

                            var ShapeID = OMS.CommonAttributesRow.getLookup().itemById[atb].ShapeId;
                            var Quality = OMS.CommonAttributesRow.getLookup().itemById[atb].QualityCode;
                            var QualityId = OMS.CommonAttributesRow.getLookup().itemById[atb].Quality_Id;
                            var Purity = OMS.CommonAttributesRow.getLookup().itemById[atb].StdPurity;
                            var Pieces = OMS.ProductRow.getLookup().itemById[prdid].Pieces;
                            var Weight = OMS.ProductRow.getLookup().itemById[prdid].Weight;

                            var Rate = OMS.ProductRow.getLookup().itemById[prdid].Rate;
                            //var Amount = OMS.ProductRow.getLookup().itemById[prdid].A;

                            var KaratRate: KaratRateRow = {
                                Product_Bom_Id: prdid,
                                Product_Code: value.Product_Code,
                                Attribute_Id: value.Product_Attribute_Id,
                                Attribute: atbCode,
                                ItemType: ItmTpy,
                                Item_Type_Id: ItmTpyId,
                                CategoryId: TypeID,
                                SubCategoryCode: SubType,
                                Stone_Color_Id: StoneColorID,
                                Metal_Color_Id: Metal_Color_Id,
                                Karat_Id: KaratId,
                                KaratCode: Karat,
                                Rate: Rate,
                                Pieces: Pieces,
                                Weight: Weight,
                                Calculate_On: value.CalcOnId,
                                Shape_Id: ShapeID,
                                Quality_Id: QualityId,
                                QualityCode: Quality,
                                StdPurity: Purity,
                                Amount:0


                                //othpcs: value.other_pieces,
                                //othwt: value.other_weight,
                                //clspcs: value.color_stone_pieces,
                                //clswt: value.color_stone_weight,
                                //netwt: value.net_weight,
                                //netamount: value.amount,
                                //diapcs: value.diamond_pieces,
                                //diawt: value.diamond_weight,
                                //bomdetails: bomdetails
                            };
                            orddetails.push(KaratRate);

                        });
                        
                        alert('Length details' + orddetails.length);
                        for (let orderDetail of orddetails) {
                            orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                            alert('ID ' + orderDetail.PrdId);
                            var x = orderDetail;
                            this.view.addItem(orderDetail);

                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        validateEntity(row: KaratRateRow, id: number) {
            if (!super.validateEntity(row, id))
                return false;


            //duplicate Component
            row.Product_Bom_Id = Q.toId(row.Product_Bom_Id);

            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.Product_Bom_Id === row.Product_Bom_Id);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Component is already in product details!');
               return false;
            }

             //update values in grid

            row.Product_Code = ProductRow.getLookup().itemById[row.Product_Bom_Id].Product_Code;
            row.FixedName = FixedCodeRow.getLookup().itemById[row.Calculate_On].FixedName;
            row.Attribute = CommonAttributesRow.getLookup().itemById[row.Attribute_Id].Attribute;
            row.ItemType = CommonAttributesRow.getLookup().itemById[row.Attribute_Id].ItemType;
            return true;
        }    
        */
    }
}